
import {
    GET_GUARDIAN_INVOICES,
    SET_GUARDIAN_INVOICES,
    SET_GUARDIAN_INVOICE,
    UPDATE_GUARDIAN_INVOICE,
    SET_GUARDIAN_INVOICES_SETTINGS,
    GENERATE_GUARDIAN_INVOICES,
    RECALCULATE_GUARDIAN_INVOICES,
    GET_GUARDIAN_INVOICE,
    SET_ACTIVE_INVOICE,
    SET_GUARDIAN_INVOICE_MONTH,
    PUBLISH_GUARDIAN_INVOICES
} from './actions';
import Vue from 'vue';
import KindergartenInvoiceService from '@/common/services/kindergarten_invoice.service';

const state = {
    invoices: [],
    selectedGuardianInvoiceMonth: null, //Month filter to use after returning from invoice view for example
    invoice: {},
    settings: {}

};
const mutations = {
    [SET_GUARDIAN_INVOICES] (state, data) {
        state.invoices = data;
    },
    [SET_GUARDIAN_INVOICES_SETTINGS](state, data) {
        state.settings = data;
    },
    [SET_GUARDIAN_INVOICE](state, {oldId, data}) {
        const index = state.invoices.findIndex(i => i.id === oldId);
        if(index > -1) {
            Vue.set(state.invoices, index, data);
        }
    },
    [SET_ACTIVE_INVOICE](state, invoice) {
        state.invoice = invoice;
    },
    [SET_GUARDIAN_INVOICE_MONTH](state, date) {
        state.selectedGuardianInvoiceMonth = date;
    }
};
const actions = {
    [GET_GUARDIAN_INVOICES]({commit, getters}, data) {
        return KindergartenInvoiceService.getGuardianInvoices(getters.activeKindergartenId, data).then(res => {
            commit(SET_GUARDIAN_INVOICES, res.invoices);
            commit(SET_GUARDIAN_INVOICES_SETTINGS, res.settings);
            return res;
        });
    },
    [GET_GUARDIAN_INVOICE]({commit, getters}, id) {
        return KindergartenInvoiceService.getGuardianInvoice(getters.activeKindergartenId, id).then(res => {
            commit(SET_ACTIVE_INVOICE, res);
        });
    },
    [GENERATE_GUARDIAN_INVOICES]({commit, getters}) {
        return KindergartenInvoiceService.generateGuardianInvoices(getters.activeKindergartenId).then(res => {
            commit(SET_GUARDIAN_INVOICES, res);
            return res;
        });
    },
    [RECALCULATE_GUARDIAN_INVOICES]({commit, getters}, data) {
        return KindergartenInvoiceService.recalculateGuardianInvoices(getters.activeKindergartenId, data).then(res => {
            commit(SET_GUARDIAN_INVOICES, res);
        });
    },
    [UPDATE_GUARDIAN_INVOICE]({commit, getters}, {id, data}) {
        return KindergartenInvoiceService.updateGuardianInvoice(getters.activeKindergartenId, id, data).then(res => {
            commit(SET_ACTIVE_INVOICE, res);
            return res.id;
        });
    },
    [PUBLISH_GUARDIAN_INVOICES]({commit, getters}, data) {
        return KindergartenInvoiceService.publishGuardianInvoices(getters.activeKindergartenId, data).then(res => {
            commit(SET_GUARDIAN_INVOICES, res.invoices);
            return res.has_inactive_guardians;
        });
    }
};
const getters = {
    guardianInvoices: state => state.invoices,
    guardianInvoiceSettings: state => state.settings,
    selectedGuardianInvoice: state => state.invoice,
    selectedGuardianInvoiceMonth: state => state.selectedGuardianInvoiceMonth
};

export default {
    state,
    mutations,
    actions,
    getters
};
